// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";
// 🔹 Replace with your Firebase Config
const firebaseConfig = {
    apiKey: "AIzaSyABgAw8zM7ixjD2HAz6-6D9jJC45wU07rc",
    authDomain: "logres-7b517.firebaseapp.com",
    projectId: "logres-7b517",
    storageBucket: "logres-7b517.firebasestorage.app",
    messagingSenderId: "197392050142",
    appId: "1:197392050142:web:5c1e9cc0600b2fd1f7df4f"
};

// 🔹 Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, provider, db, doc, setDoc, getDoc };
